export enum ReportsTypes {
    QUICK_VIEW = 1,
    CUSTOM_FILTERING = 2,
}
